var React = require('react');

function UiRoundReplay (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"stroke":"#FFF","strokeWidth":"2"},[React.createElement("path",{"d":"M60 85c13.807 0 25-11.193 25-25S73.807 35 60 35 35 46.193 35 60v7.5","key":0}),React.createElement("path",{"d":"M27.5 60l7.5 7.5 7.5-7.5","key":1})])));
}

UiRoundReplay.defaultProps = {"width":"120","height":"120","viewBox":"0 0 120 120"};

module.exports = UiRoundReplay;

UiRoundReplay.default = UiRoundReplay;
